import { React, useEffect } from 'react'
import './RedirectMenu.css'
import { useState } from 'react'
import { motion, AnimatePresence, delay } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import { Card, CardBody } from "@nextui-org/react";
import logo from '../Images/logo-transparent.png'
import FormComponent from '../components/FormComponents/FormComponent';
import PortalComponents from '../components/PortalComponents/PortalComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import profpic from "../Images/profpic.jpeg"
import { Button } from "@nextui-org/react";
import { Avatar } from "@nextui-org/react";
import { VictoryBar } from 'victory';
import axios from 'axios';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import LoadingScreen from '../LoadingScreen/LoadingScreen';

import SidePanel from '../components/SidePanel/SidePanel';
import { Routes, Route, useNavigate } from 'react-router-dom';
import BackEndUrl from '../backURL';
import LogoutButton from '../components/Logout/LogoutButton';
const backend = BackEndUrl.domain
const RedirectMenu = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    async function GetData() {
      try {
        const response = await axios.post(backend + "/policy-load", {          
          nic: sessionStorage.getItem('nic'),
          mobile: sessionStorage.getItem('mobile'),
        },{
          headers:{
            Authorization: sessionStorage.getItem('token'),
          }
        }
        );
        setData(response.data);
 
      } catch (error) {
        console.log(error);
      }
    }
   

    if (!data) {
      GetData();
    }
  

  }, [data]);

  if (sessionStorage.getItem('nic')) {
    if (data) {
     
      return (<div

        className='container-redirect'>

        <Row className=' d-flex justify-content-center ' style={{ height: "100%",margin:0 }}>
          <Col lg={10} xs={12} sm={12} md={11} className=' d-flex justify-content-center align-items-center'>
            <motion.div
              className=' d-flex justify-content-center align-items-center'
              initial={
                {
                  opacity: 0,
                  scale: "0%"
                }
              }
              animate={{
                opacity: 1,
                scale: "100%"
              }}
            >
              <Col lg={7}xs={12} sm={12} md={11} className='d-flex justify-content-center align-items-center'>
                <Card
                  isBlurred
                  className="border-none bg-background/60 dark:bg-default-100/50 max-w-[610px]"
                  shadow="sm"
                  style={{ width: "100%", height: "80vh", minWidth: "50vw" }}
                >
                  <CardBody>
                    <Row className='d-flex justify-content-between '>
                      <Col xs={3} className='mx-3 my-3 ' >
                        <img src={logo} style={{ width: "40%" }} />
                      </Col>
                      <Col xs={3} className='mx-3 my-3  d-flex justify-content-end' >
                      

                       
                       <LogoutButton/> 
                      
                      </Col>
                      
                      
                    </Row>
                    <Row style={{ textAlign: "center",margin:0  }}>
                      <h1 style={{ fontSize: "30px", color: "#45BADD" }}>Select the Policy</h1>
                    </Row>
                    
                   
                    <div className='button-con d-flex justify-content-center align-items-center' >
                      {
                        data.map((item, index) => {
                          return (

                            <div key={`policy-btn${index}`} className='policy-btn-con' >
                              <a href={`/customer-portal?policy-id=${item.policy_number}`} className='btn-link'>   < Button className='policy-btn  d-flex justify-content-between' style={{ backgroundColor: "#F7941E", color: "white" }}><div className='d-flex justify-content-center' style={{ width: "100%" }}><p>{item.policy_number}</p></div>   <FontAwesomeIcon icon={faArrowRight} /></Button></a>
                            </div>


                          )

                        })
                      }




                    </div>


                  </CardBody>
                </Card>
              </Col>
            </motion.div>
          </Col>
        </Row>


      </div>)
    }
    else {
      return (
        <LoadingScreen />
      )
    }
  }
  else{
    window.location.href="/customer-portal/login"
  }




}

export default RedirectMenu
